export const queryKeys = {
    FORM_LEAD_FILTER: 'FORM_LEAD_FILTER',
    FORM_LEAD_FILTER_EXCEL: 'FORM_LEAD_FILTER_EXCEL',
    GET_FORM_REPORT: 'GET_FORM_REPORT'
} 